/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getActivities } from "../../../../store/actions";
import moment from "moment";
import { toAbsoluteUrl } from "../../../_helpers/AssetsHelpers";
import { getBaseImageURL } from "../../../../helpers";
import LanguageReplaceText from "../../../../_metronic/_helpers/activityHelper";

export function ListsWidget9({ className }) {
  const navigate = useNavigate();
  const { activities } = useSelector((state) => state.activity);
  const dispatch = useDispatch();
  const globalImagePath = useRef(getBaseImageURL());

  useEffect(() => {
    dispatch(getActivities(1));
  }, [dispatch]);

  const activity = activities ? (
    activities.map((activity, key) => (
      <div key={key}>
        <div className="activity-card d-flex align-items-center px-3 py-2 rounded-fix mb-3">
          <div
            className="me-5"
            style={{
              width: "40px",
              height: "40px",
            }}>
            <img
              className="w-100 h-100 rounded-circle"
              alt="user"
              src={
                activity?.thumbnail === undefined
                  ? toAbsoluteUrl(`media/users/default.jpg`)
                  : `${globalImagePath.current}${activity?.thumbnail}`
              }
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = toAbsoluteUrl("media/users/default.jpg");
              }}
            />
          </div>
          <div className="fw-bold activity-title">
            <LanguageReplaceText
              languageText={activity?.languageText}
              textToReplace={activity?.textToReplace}
              defaultText={activity?.text}
            />
            <span className="text-muted d-block activity-time">
              {moment(activity.createdAt).fromNow()}
            </span>
          </div>
        </div>
      </div>
    ))
  ) : (
    <h1>No New Data</h1>
  );
  function viewAll() {
    navigate("activities");
  }
  return (
    <>
      <div className={`card card-custom ${className}`}>
        {/* Header */}
        <div className="card-header d-flex align-items-center justify-content-between border-0 px-4 py-5">
          <h3 className="h5 fw-bold text-dark mb-0">Recent Activities</h3>
          <button
            type="button"
            onClick={viewAll}
            className="view-all-btn fw-bold">
            View All
          </button>
        </div>
        {/* Body */}
        <div className="card-body pt-0 activities-wrapper thin-scrollbar px-5">
          {activity.slice(0, 5)}
        </div>
      </div>
    </>
  );
}
